import { useMutation, useQueryClient } from '@tanstack/react-query';
import { centsApi } from '@/api/services/cents';
import type { CreateCentDto, UpdateCentDto } from '@/api/types/cents';

export const centKeys = {
  all: ['cents'] as const,
  list: ['cents', 'list'] as const,
};

export function useCreateCent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCentDto) => centsApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: centKeys.list }),
  });
}

export function useUpdateCent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateCentDto }) =>
      centsApi.update(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: centKeys.list }),
  });
}

export function useDeleteCent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => centsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: centKeys.list }),
  });
}
